import { PlayPauseButton } from "@/components/atoms/PlayPauseButton";
import { SkipButton } from "@/components/atoms/SkipButton";
import { SkipDirection } from "@/components/atoms/SkipButton/types";
import { useClassNames } from "@/utils/classNames";

import styles from "./VideoControls.module.scss";
import { VideoControlsProps } from "./types";

/**
 * Video player controls molecule that composes play/pause and skip buttons
 *
 * @param props - The video controls properties
 * @returns the video controls component
 */
const VideoControls = ({
  isPlaying,
  onPlayPause,
  onSkipBackward,
  onSkipForward,
  skipSeconds = 10,
  className,
}: VideoControlsProps) => {
  const cn = useClassNames(styles, styles["video-controls"], className);

  return (
    <div className={cn}>
      <SkipButton
        direction={SkipDirection.Backward}
        seconds={skipSeconds}
        onClick={onSkipBackward}
      />

      <PlayPauseButton isPlaying={isPlaying} onClick={onPlayPause} />

      <SkipButton
        direction={SkipDirection.Forward}
        seconds={skipSeconds}
        onClick={onSkipForward}
      />
    </div>
  );
};

export { VideoControls };
